import { t } from "i18next";
import { authMethod } from "../config/appProperties";
import { getRunsForList } from "./authentication";

export const getHeadervisible = () => {
  if (getCookie1('token')) {
    return true;
  }
  return false;
}

export const setCookie = (cname, cvalue, hours) => {
  var d = new Date();
  d.setTime(d.getTime() + hours * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie =
    cname +
    "=" +
    cvalue +
    ";" +
    expires +
    ";domain=" +
    window.location.hostname +
    ";path=/";
}

export const setCookie1 = (cname, cvalue, time) => {
  var d = new Date();
  d.setTime(time * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie =
    cname +
    "=" +
    cvalue +
    ";" +
    expires +
    ";domain=" +
    window.location.hostname +
    ";path=/;";
}

export function deleteCookie(cookiename) {
  const d = new Date(0)
  const expires = 'expires=' + d.toUTCString()
  document.cookie = cookiename + '=\'\';' + expires + ';path=/'
}

export const GetToken = () => {
  let token;
  if (authMethod === "Basic") {
    token = "Basic " + getCookie1("token");
  } else {
    token = "Bearer " + getCookie1("token");
  }
  return token;
}

export const getCookie1 = (id) => {
  var allcookies = document.cookie;
  let cookiearray = allcookies.split(";");
  for (var i = 0; i < cookiearray.length; i++) {
    let name = cookiearray[i].split("=")[0];
    let value = cookiearray[i].split("=")[1];
    if (id?.trim() === name?.trim()) return value;
  }
  return null;
}

export const CheckWebsiteCookies = (name) => {
  var dc = document.cookie;
  var prefix = name + "=";
  var begin = dc.indexOf("; " + prefix);
  if (begin === -1) {
    begin = dc.indexOf(prefix);
    if (begin !== 0) return null;
  } else {
    begin += 2;
    var end = document.cookie.indexOf(";", begin);
    if (end === -1) {
      end = dc.length;
    }
  }
  return decodeURI(dc.substring(begin + prefix.length, end));
}
export const IsUserLogin = () => {
  if (CheckWebsiteCookies("token")) {
    return true;
  } else {
    return false;
  }
}
export const logOutFunction = (cname, cvalue) => {
  var d = new Date(0);
  d.setTime(d.getTime());
  var expires = "expires=" + d.toUTCString();
  document.cookie =
    cname +
    "=" +
    cvalue +
    ";" +
    expires +
    ";domain=" +
    window.location.hostname +
    ";path=/";
}

export const formatDate = (date) => {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}
export const getGenderByKey = (val) => {
  if (val == "M") {
    return "Male";
  } else if (val == "F") {
    return "Female";
  } else if (val == "O") {
    return "Other";
  }
}
export const getGenderKey = (val) => {
  if (val == "Male") {
    return "M";
  } else if (val == "Female") {
    return "F";
  } else if (val == "Other") {
    return "O";
  }
}

export const saveUserProfileDataTOStorage = (data, generalProfile, eventMapping) => {
  let userProf = {};
  let userDtls = {};
  userDtls.dob = data["dob"];
  userDtls.email = data["email"];
  userDtls.firstName = data["firstName"];
  userDtls.name = data["fullName"];
  userDtls.lastName = data["lastName"];
  userDtls.picUrl = data["picUrl"];
  userDtls.salutation = data["salutation"];
  userDtls.mobileCode = data["mobileCode"];
  userDtls.phoneNumber = data["phoneNumber"];
  userDtls.runnerId = data["runnerId"];
  userDtls.gender = data["gender"];
  userDtls.strDob = data["strDob"];
  userDtls.emailVerified = data["emailVerified"];
  userDtls.mobileVerified = data["mobileVerified"];
  userDtls.updateProfile = data["updateProfile"];
  userDtls.missingProfile = data["missingProfile"];
  if (eventMapping) {
    userDtls.eventMapping = eventMapping;
  }
  if (generalProfile) {
    userDtls.mainProfile = generalProfile;
  }
  userProf.status = true;
  userProf.profile = userDtls;
  userProf.msg = "Profile Details";
  localStorage.setItem("userDtls", JSON.stringify(userProf));
}

export const sortQuestionByEventIde = (array) => {
  if (array) {
    return array.sort(function (a, b) {
      if (a["eventId"] < b["eventId"]) {
        return -1;
      } else if (a["eventId"] > b["eventId"]) {
        return 1;
      } else {
        return 0;
      }
    });
  }
}

export const createDateSorting = (array) => {
  if (array) {
    return array.sort(function (a, b) {
      if (a["createdTs"] > b["createdTs"]) {
        return -1;
      } else if (a["createdTs"] < b["createdTs"]) {
        return 1;
      } else {
        return 0;
      }
    });
  }
}

export const getCurrentUser = () => {
  let userDtls = JSON.parse(localStorage.getItem("userDtls"));
  return userDtls;
}

export const getRuns = () => {
  getRunsForList().then(
    (response) => {
      let obj = {
        startDate: response?.data["data"]["startDate"],
        endDate: response?.data["data"]["endDate"]
      }
      localStorage.setItem("wsded", JSON.stringify(obj));
    },
    (error) => {
      console.error(error);
    }
  );
}

export const getServerErrorMessage = ({ error,
  errorCode,
  msg,
  status,
}) => {
  const key = `errorCodes.${error?.code}`;
  const fondError = t(key);
  const errorMsg =
    fondError && fondError != key ? fondError : error?.message;
  return errorMsg;
};

export const truncateString = (str, length = 12) => {
  if (str && str.length > 12) {
    return str.substring(0, length) + "...";
  } else {
    return str;
  }
}

export const getSkippedReason = (
  errorCode,
  msg
) => {
  const key = `errorCodes.${errorCode}`;
  const fondError = t(key);
  const errorMsg =
    fondError && fondError != key ? fondError : msg;
  return errorMsg;
};